<template>
  <div class="axj-show-club">
    <show-club-header
      @create="handleCreate"
    />
    <show-club-main
      :data="tableData"
      @update="handleUpdate"
      @delete="handleDeleteShowClub"
    />
    <show-club-footer
      :page-data="page"
      @page-change="handlePaginationChange"
    />
    <show-club-edit
      @close="handleClubClose"
      :show.sync="clubEdit.show"
      :is-create="clubEdit.create"
      :clubId="clubEdit.clubId"
      @updated="handleUpdated"
      @created="handleCreated"
    />

  </div>
</template>

<script>
import ShowClubMain from "./component/show-club-main/index";
import ShowClubFooter from "./component/show-club-footer/index";
import ShowClubEdit from "./action/showClubEdit";
import ShowClubHeader from "./component/show-club-header/index";
import commonModels from '@/common/models/common-models'
export default {
  name: "axj-show-club",
  components: {ShowClubHeader, ShowClubEdit, ShowClubFooter, ShowClubMain},
  created() {
    this.initData()
    let that=this
    window.handleNext=function (){
      if(that.page.page*that.page.limit<that.page.pageTotal){
        that.page.page=that.page.page+1
        that.handlePaginationChange(that.page)
      }
    }
    window.handlePre=function (){
      if(that.page.page>1){
        that.page.page=that.page.page-1
        that.handlePaginationChange(that.page)
      }
    }
  },
  data(){
    return {
      tableData:[],
      page: {
        page: 1,
        limit: 5,
        desc: true,
        preload: true,
        pageTotal: 0
      },
      clubEdit:{
        create:true,
        show:false,
        clubId:undefined
      }
    }
  },
  methods:{
    handleDeleteShowClub(id){
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.deleteShowClub(id)
        this.initData()
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    deleteShowClub(id){
      return new Promise((resolve, reject)=>{
        this.$api.axjExtracurricularApi.showClub.deleteShowClub(id).then(res=>{
          resolve()
        },error => {
        })
      })
    },
    handlePaginationChange (val) {
      this.page = val
      this.initData()
    },
    handleClubClose(){
      this.clubEdit.show=false
    },
    handleCreate(){
      this.clubEdit.create=true
      this.clubEdit.show=true
    },
    initData(){
      let user=this.$store.getters.getUser
      this.$api.axjExtracurricularApi.showClub.listShowClub({
        ...this.page,
        where:JSON.stringify({
          user_id:user.extraShowClubUid
        }),
        preload:true
      }).then(res=>{
        this.tableData=res.data.lists
        this.page.pageTotal=res.data.total
        commonModels.logs('extra','showClub','show-club-list-success!',0)
      },error=>{

      })
    },
    handleUpdate(id){
      this.clubEdit.clubId=id
      this.clubEdit.create=false
      this.clubEdit.show=true
    },
    handleUpdated(){
      this.clubEdit.show=false
      this.initData()
    },
    handleCreated(){
      this.clubEdit.show=false
      this.initData()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/axj-extracurricular/axj-show-club/index.vue